import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePost } from '../hooks/usePost'
import { usePut } from '../hooks/usePut'
import { useGet } from '../hooks/useGet'
import { RadAppLayout } from '../common/RadAppLayout'
import { RadHeader } from '../common/RadHeader'
import { RadForm } from '../common/RadForm'
import { RadInput } from '../common/RadInput'
import { RadFormField } from '../common/RadFormField'
import { RadButton } from '../common/RadButton'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { RadContainer } from '../common/RadContainer'

export function ServiceEdit () {
  const navigate = useNavigate()
  const { serviceId } = useParams()
  const [formValues, setFormValues] = useState()
  const { data: service } = useGet(serviceId ? `/api/service/${serviceId}` : null)

  useEffect(() => {
    const defaultFormValues = { }
    setFormValues(service ?? defaultFormValues)
  }, [service])

  const create = usePost('/api/service', formValues, (resp) => { navigate(`/service/${resp.id}`) })
  const update = usePut(`/api/service/${serviceId}`, formValues, (resp) => { navigate(`/service/${serviceId}`) })

  async function saveChanges () {
    if (serviceId != null) { update() } else { create() }
  }

  async function cancel () {
    if (serviceId != null) {
      navigate(`/service/${serviceId}`)
    } else {
      navigate('/service')
    }
  }

  if (formValues != null) {
    return (
      <RadAppLayout
        name={formValues.name}
        contentHeader={
          <RadHeader variant='h1'>
            {formValues.id != null ? 'Edit Service' : 'New Service'}
          </RadHeader>
        }
        content={
          <form onSubmit={e => e.preventDefault()}>
            <RadForm
              actions={
                <RadSpaceBetween direction='horizontal' size='xs'>
                  <RadButton variant='link' onClick={cancel}>Cancel</RadButton>
                  <RadButton formAction='submit' variant='primary' onClick={saveChanges}>Save Changes</RadButton>
                </RadSpaceBetween>
              }
            >
              <RadSpaceBetween size='l'>
                <RadContainer
                  header={
                    <RadHeader variant='h2'>
                      Details
                    </RadHeader>
                  }
                >
                  <RadSpaceBetween size='l'>
                    <RadFormField label='Name *' field='name'>
                      <RadInput
                        placeholder='Enter name'
                        ariaRequired
                        value={formValues.name}
                        onChange={({ detail }) => setFormValues({ ...formValues, name: detail.value })}
                        disabled={formValues.isProtected}
                      />
                    </RadFormField>
                  </RadSpaceBetween>
                </RadContainer>
              </RadSpaceBetween>
            </RadForm>
          </form>
        }
      />
    )
  }
}
